let elementName = `nss-buybox-gallery-variant`;
if (typeof customElements.get(elementName) === `undefined`) {

  class NSSBuyboxGallery extends HTMLElement {

    constructor() {
      super();

      this.debug = false;

      this.els = {
        swiperMain: this.querySelector(`.js-nss-buybox-gallery-main`),
        swiperThumb: this.querySelector(`.js-nss-buybox__gallery-thumb`),
        swiperPrev: this.querySelector(`.swiper-button-prev`),
        swiperNext: this.querySelector(`.swiper-button-next`)
      };

      this.swiper = {
        main: null,
        thumb: null,
      }
      
      this.id = this.getAttribute(`nss-variant-id`);
    }

    connectedCallback() {
      if (this.debug) console.log(`[NSS][Buybox Gallery] Connected.`);

      this.initGallery();
      this.addEventListener(`buyboxUpdate`, this.handleUpdate.bind(this));
    }

    initGallery() {
      const isDesktop = window.matchMedia('(min-width: 990px)').matches;

      if (this.els.swiperThumb != null && isDesktop) {
        this.swiper.thumb = new Swiper(this.els.swiperThumb, {
          spaceBetween: 16,
          slidesPerView: 'auto',
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          direction: 'vertical',
          freeMode: true,
        });
      }

      if (this.els.swiperMain != null) {
        this.swiper.main = new Swiper(this.els.swiperMain, {
          spaceBetween: 16,
          slidesPerView: 'auto',
          scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
          },
          navigation: {
            prevEl: this.els.swiperPrev,
            nextEl: this.els.swiperNext,
          },
            thumbs: this.swiper.thumb ? { swiper: this.swiper.thumb } : {},
          on: {
            slideChange: () => {
              this.pauseInternalVideos();
              this.updateBadgeVisibility();
            },
          },
        });
      }
    }
      updateBadgeVisibility() {
      const badge = this.querySelector('.nss-buybox__gallery-badge');
      if (!badge) return;
      badge.classList.toggle('nss-buybox__gallery-badge--hidden', this.swiper.main.activeIndex !== 0);
    }

    pauseInternalVideos() {
          const videoCards = this.querySelectorAll('nss-video-card');
          videoCards.forEach(card => {
              if (typeof card.pause === 'function') {
                  card.pause();
              } else {
                  const videos = card.querySelectorAll('video');
                  videos.forEach(v => v.pause());
              }
          });
      }
    handleUpdate(e) {
      const oldId = e.detail.oldId;
      const newId = e.detail.newId;
      if (newId === this.id) {
        this.classList.add(`nss-active`);
      } else {
        // setTimeout(() => {
          this.classList.remove(`nss-active`);
        // }, 125);
      }
    }
  }

  customElements.define(elementName, NSSBuyboxGallery);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`);
}

(function () {
  // Build the single shared gallery modal for a given variant by cloning its
  // <template> slides, then (re)initializing the modal Swiper.
  function populateModal(modal, variantId) {
    var swiperEl = modal.querySelector('.js-nss-buybox-gallery-modal');
    var wrapper = swiperEl && swiperEl.querySelector('.swiper-wrapper');
    var tpl = document.querySelector('.js-nss-gallery-modal-slides[data-variant-id="' + variantId + '"]');
    if (!swiperEl || !wrapper || !tpl) return;

    // Skip rebuild if the modal already holds this variant's slides
    if (modal._currentVariantId === variantId && modal._gallerySwiper) return;
    modal._currentVariantId = variantId;

    if (modal._gallerySwiper) {
      modal._gallerySwiper.destroy(true, true);
      modal._gallerySwiper = null;
    }
    wrapper.innerHTML = '';
    wrapper.appendChild(tpl.content.cloneNode(true));

    modal._gallerySwiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        // Pagination lives outside the swiper (sibling) so the dots can sit
        // below the image instead of overlaying it.
        el: modal.querySelector('.swiper-pagination'),
        clickable: true,
      },
    });

    // Jump to the clicked slide once the modal becomes visible
    if (!modal._openObserverBound) {
      modal._openObserverBound = true;
      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          if (m.attributeName === 'class' && modal.classList.contains('is-visible') && modal._gallerySwiper) {
            modal._gallerySwiper.update();
            modal._gallerySwiper.slideTo(modal._pendingSlideIndex || 0, 0);
          }
        });
      }).observe(modal, { attributes: true, attributeFilter: ['class'] });
    }
  }

  // On trigger click (capture phase), build the modal for the active variant
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.js-nss-modal-trigger[data-slide-index]');
    if (!trigger) return;
    var modal = document.querySelector('nss-modal[data-modal="' + trigger.getAttribute('data-modal') + '"]');
    if (!modal) return;

    var galleryVariant = trigger.closest('nss-buybox-gallery-variant');
    var variantId = galleryVariant && galleryVariant.getAttribute('nss-variant-id');
    if (variantId) populateModal(modal, variantId);

    modal._pendingSlideIndex = parseInt(trigger.getAttribute('data-slide-index') || '0', 10);
  }, true);
})();